import axiosInstance from "../utils/axiosInstance";
import type { ListItemData } from "../../components/lists/GenericList";

interface BackendApiResponse {
  items: ListItemData[];
  lastKey: string | null;
}

export const listTextTransforms = async (
  lastKey?: string,
): Promise<{ items: ListItemData[]; lastKey: string | null }> => {
  try {
    const response = await axiosInstance.get<BackendApiResponse>("/text-transform/list", {
      params: lastKey ? { lastKey } : {},
    });

    if (response.data && Array.isArray(response.data.items)) {
      return {
        items: response.data.items,
        lastKey: response.data.lastKey ?? null,
      };
    }

    return { items: [], lastKey: null };
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to list text transforms.");
  }
};
